export const states = [
  {
    StateCode: 'AL',
    State: 'Alabama',
    TotalStandardStateFee: 346.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 161.0,
  },
  {
    StateCode: 'AK',
    State: 'Alaska',
    TotalStandardStateFee: 360.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'AZ',
    State: 'Arizona',
    TotalStandardStateFee: 190.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 139.0,
  },
  {
    StateCode: 'AR',
    State: 'Arkansas',
    TotalStandardStateFee: 149.0,
    NormalProcessingDays: 7,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'CA',
    State: 'California',
    TotalStandardStateFee: 196.0,
    NormalProcessingDays: 6,
    TotalDBAFees: 170.0,
  },
  {
    StateCode: 'CO',
    State: 'Colorado',
    TotalStandardStateFee: 154.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 149.0,
  },
  {
    StateCode: 'CT',
    State: 'Connecticut',
    TotalStandardStateFee: 226.0,
    NormalProcessingDays: 7,
    TotalDBAFees: 144.0,
  },
  {
    StateCode: 'DE',
    State: 'Delaware',
    TotalStandardStateFee: 216.0,
    NormalProcessingDays: 7,
    TotalDBAFees: 129.0,
  },
  {
    StateCode: 'FL',
    State: 'Florida',
    TotalStandardStateFee: 232.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 180.0,
  },
  {
    StateCode: 'GA',
    State: 'Georgia',
    TotalStandardStateFee: 211.0,
    NormalProcessingDays: 12,
    TotalDBAFees: null,
  },
  {
    StateCode: 'HI',
    State: 'Hawaii',
    TotalStandardStateFee: 155.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 155.0,
  },
  {
    StateCode: 'ID',
    State: 'Idaho',
    TotalStandardStateFee: 210.0,
    NormalProcessingDays: 15,
    TotalDBAFees: 156.0,
  },
  {
    StateCode: 'IL',
    State: 'Illinois',
    TotalStandardStateFee: 261.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 287.0,
  },
  {
    StateCode: 'IN',
    State: 'Indiana',
    TotalStandardStateFee: 214.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 159.0,
  },
  {
    StateCode: 'IA',
    State: 'Iowa',
    TotalStandardStateFee: 154.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 134.0,
  },
  {
    StateCode: 'KS',
    State: 'Kansas',
    TotalStandardStateFee: 274.0,
    NormalProcessingDays: 1,
    TotalDBAFees: null,
  },
  {
    StateCode: 'KY',
    State: 'Kentucky',
    TotalStandardStateFee: 144.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 149.0,
  },
  {
    StateCode: 'LA',
    State: 'Louisiana',
    TotalStandardStateFee: 211.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 211.0,
  },
  {
    StateCode: 'ME',
    State: 'Maine',
    TotalStandardStateFee: 338.0,
    NormalProcessingDays: 3,
    TotalDBAFees: 312.0,
  },
  {
    StateCode: 'MD',
    State: 'Maryland',
    TotalStandardStateFee: 262.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 208.0,
  },
  {
    StateCode: 'MA',
    State: 'Massachusetts',
    TotalStandardStateFee: 638.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 211.0,
  },
  {
    StateCode: 'MI',
    State: 'Michigan',
    TotalStandardStateFee: 154.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'MN',
    State: 'Minnesota',
    TotalStandardStateFee: 262.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 180.0,
  },
  {
    StateCode: 'MS',
    State: 'Mississippi',
    TotalStandardStateFee: 158.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'MO',
    State: 'Missouri',
    TotalStandardStateFee: 156.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 136.0,
  },
  {
    StateCode: 'MT',
    State: 'Montana',
    TotalStandardStateFee: 139.0,
    NormalProcessingDays: 8,
    TotalDBAFees: 149.0,
  },
  {
    StateCode: 'NE',
    State: 'Nebraska',
    TotalStandardStateFee: 210.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 235.0,
  },
  {
    StateCode: 'NV',
    State: 'Nevada',
    TotalStandardStateFee: 552.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'NH',
    State: 'New Hampshire',
    TotalStandardStateFee: 208.0,
    NormalProcessingDays: 15,
    TotalDBAFees: 180.0,
  },
  {
    StateCode: 'NJ',
    State: 'New Jersey',
    TotalStandardStateFee: 237.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 180.0,
  },
  {
    StateCode: 'NM',
    State: 'New Mexico',
    TotalStandardStateFee: 156.0,
    NormalProcessingDays: 2,
    TotalDBAFees: null,
  },
  {
    StateCode: 'NY',
    State: 'New York',
    TotalStandardStateFee: 314.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'NC',
    State: 'North Carolina',
    TotalStandardStateFee: 235.0,
    NormalProcessingDays: 25,
    TotalDBAFees: 235.0,
  },
  {
    StateCode: 'ND',
    State: 'North Dakota',
    TotalStandardStateFee: 242.0,
    NormalProcessingDays: 10,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'OH',
    State: 'Ohio',
    TotalStandardStateFee: 205.0,
    NormalProcessingDays: 7,
    TotalDBAFees: 169.0,
  },
  {
    StateCode: 'OK',
    State: 'Oklahoma',
    TotalStandardStateFee: 211.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 211.0,
  },
  {
    StateCode: 'OR',
    State: 'Oregon',
    TotalStandardStateFee: 206.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 206.0,
  },
  {
    StateCode: 'PA',
    State: 'Pennsylvania',
    TotalStandardStateFee: 232.0,
    NormalProcessingDays: 5,
    TotalDBAFees: 201.0,
  },
  {
    StateCode: 'RI',
    State: 'Rhode Island',
    TotalStandardStateFee: 263.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 263.0,
  },
  {
    StateCode: 'SC',
    State: 'South Carolina',
    TotalStandardStateFee: 232.0,
    NormalProcessingDays: 2,
    TotalDBAFees: null,
  },
  {
    StateCode: 'SD',
    State: 'South Dakota',
    TotalStandardStateFee: 257.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 257.0,
  },
  {
    StateCode: 'TN',
    State: 'Tennessee',
    TotalStandardStateFee: 421.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 150.0,
  },
  {
    StateCode: 'TX',
    State: 'Texas',
    TotalStandardStateFee: 422.0,
    NormalProcessingDays: 2,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'UT',
    State: 'Utah',
    TotalStandardStateFee: 159.0,
    NormalProcessingDays: 25,
    TotalDBAFees: 151.0,
  },
  {
    StateCode: 'VT',
    State: 'Vermont',
    TotalStandardStateFee: 262.0,
    NormalProcessingDays: 3,
    TotalDBAFees: 180.0,
  },
  {
    StateCode: 'VA',
    State: 'Virginia',
    TotalStandardStateFee: 206.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 139.0,
  },
  {
    StateCode: 'WA',
    State: 'Washington',
    TotalStandardStateFee: 309.0,
    NormalProcessingDays: 5,
    TotalDBAFees: 154.0,
  },
  {
    StateCode: 'WV',
    State: 'West Virginia',
    TotalStandardStateFee: 207.0,
    NormalProcessingDays: 9,
    TotalDBAFees: null,
  },
  {
    StateCode: 'WI',
    State: 'Wisconsin',
    TotalStandardStateFee: 237.0,
    NormalProcessingDays: 1,
    TotalDBAFees: 144.0,
  },
  {
    StateCode: 'WY',
    State: 'Wyoming',
    TotalStandardStateFee: 210.0,
    NormalProcessingDays: 3,
    TotalDBAFees: 232.0,
  },
];

export const options = [
  { value: 'business_domain', label: 'Business Domain', price: 4.95 },
  { value: 'website', label: 'Website', price: 5 },
  { value: 'business_email', label: 'Business Email', price: 5 },
  { value: 'phone_service', label: 'Phone Service', price: 5 },
];

export const getSelectedState = (st) => states.find((el) => el.StateCode === st);

export const getPrice = (op) => options.find((el) => el.value === op)?.price;
export const getName = (op) => options.find((el) => el.value === op)?.label;

export const industries = [
  { label: 'Landscaping', value: 'Landscaping' },
  { label: 'Food Truck', value: 'Food Truck' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'E-commerce', value: 'E-commerce' },
  { label: 'Restaurant', value: 'Restaurant' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Other', value: 'Other' },
];

export const faqs = [
  {
    q: 'What is a registered agent?',
    a: 'A registered agent is an individual or service designated to receive legal documents and official mail on your behalf during business hours. It’s required by law in most jurisdictions.',
  },
  {
    q: 'What is a Certificate/Articles of Incorporation?',
    a: 'These are the official documents filed with your state to formally create your company—often called “Articles of Incorporation” or “Certificate of Incorporation” depending on state regulations.',
  },
  {
    q: 'What is the cost of forming an LLC?',
    a: 'Costs vary by state—each has its own filing fee for Articles/Certificate of Incorporation. Additional costs may include expedited service, legal help, or trademark registration.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major US credit and debit cards.',
  },
  {
    q: 'Where can I find my orders and documents?',
    a: 'Once the order is complete, you can sign in to your Thera dashboard to track progress and access your documents.',
  },
];

export const pricingFaqs = [
  {
    q: 'What is a registered agent?',
    a: 'A registered agent is an individual or service designated to receive legal documents and official mail on your behalf during business hours. It’s required by law in most jurisdictions.',
  },
  {
    q: 'What is a Certificate/Articles of Incorporation?',
    a: 'These are the official documents filed with your state to formally create your company—often called “Articles of Incorporation” or “Certificate of Incorporation” depending on state regulations.',
  },
  {
    q: 'What is the cost of forming an LLC?',
    a: 'Costs vary by state—each has its own filing fee for Articles/Certificate of Incorporation. Additional costs may include expedited service, legal help, or trademark registration.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major US credit and debit cards.',
  },
  {
    q: 'Where can I find my orders and documents?',
    a: 'Once the order is complete, you can sign in to your Thera dashboard to track progress and access your documents.',
  },
];
